import { createRegisterableComposition } from 'common/routing/page-definition'
import React from 'react'
import { FeatureArticleBreach } from './FeatureArticleBreach'
import { getPublicationPageProperties } from 'component-library/templates/Publication/lib/publication-page-properties'
import { PageAdditionalProps } from 'page-lifecycle-provider'
import { getPublicationInfoFromRouteResolution } from 'component-library/templates/Publication/SharedPublication.routing'

interface Props {
    isPremium: boolean
    publicationId: string
    slug: string
}

export const FeatureArticleBreachCompositionRegistration = createRegisterableComposition<
    'main' | 'common'
>()('article-breach-composition', (contentAreas, props: Props, services) => {
    const publicationInfo = getPublicationInfoFromRouteResolution(services)

    // DPT-1856 - PageAdditionalProps required here at top most of featured article template or
    // events were firing twice, moved from TheWestFeature.routing
    return (
        <PageAdditionalProps
            pageProperties={getPublicationPageProperties(publicationInfo.publication)}
        >
            <FeatureArticleBreach
                isPremium={props.isPremium}
                location={services.location}
                onEvent={services.onEvent}
                commonElements={contentAreas.common}
                publicationId={props.publicationId}
                slug={props.slug}
            >
                {contentAreas.main}
            </FeatureArticleBreach>
        </PageAdditionalProps>
    )
})
